import { apiGet, apiPost } from "@/shared/api";
import type { AssistantNotification } from "./types";

export async function fetchNotifications(
  unreadOnly = false,
  limit = 50,
): Promise<AssistantNotification[]> {
  const q = new URLSearchParams({ unread: unreadOnly ? "1" : "0", limit: String(limit) });
  return apiGet<AssistantNotification[]>(`/api/assistant/notifications?${q}`);
}

export async function markNotificationRead(id: number): Promise<AssistantNotification> {
  return apiPost<AssistantNotification>(`/api/assistant/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  return apiPost<{ updated: number }>("/api/assistant/notifications/read-all");
}
